import { Link } from 'react-router-dom'
import { BRAND_LOGO_ALT, BRAND_LOGO_SRC } from '../../config/brand'
import './BrandLogo.css'

export type BrandLogoVariant = 'app' | 'auth' | 'landing' | 'landing-sm'

type BrandLogoProps = {
  variant?: BrandLogoVariant
  to?: string
  className?: string
  linkClassName?: string
  onClick?: () => void
}

export default function BrandLogo({
  variant = 'app',
  to,
  className,
  linkClassName,
  onClick,
}: BrandLogoProps) {
  const img = (
    <img
      src={BRAND_LOGO_SRC}
      alt={BRAND_LOGO_ALT}
      className={['brand-logo', `brand-logo--${variant}`, className].filter(Boolean).join(' ')}
    />
  )

  if (to) {
    return (
      <Link to={to} className={['brand-logo-link', linkClassName].filter(Boolean).join(' ')} onClick={onClick}>
        {img}
      </Link>
    )
  }

  return img
}
